module.exports = __webpack_public_path__ + "static/Verne6-c93442659b43a8e49dbe1bfdaf5d6deb.webp";